import { Icons } from '@monoimin/atoms';
import { IS_PROD } from '@monoimin/constants';

export const RichTextPreviewMessage = () => {
  if (!IS_PROD) {
    return (
      <div className='flex flex-col gap-5 border border-border p-5 max-w-[400px]'>
        <p className='before:block before:absolute before:-inset-1 w-fit before:-skew-y-3 before:roudned-md before:bg-red relative inline-block'>
          <span className='relative body text-white font-bold'>
            ошибка в richtext
          </span>
        </p>
        <p className='caption flex flex-row items-start gap-3'>
          <Icons
            icon='attention'
            isInteractive
            as='span'
            className='bg-orange inline-flex'
            sizeClassName='h-5 w-5'
          />
          <span className='opacity-65'>
            попробуйте пересобрать текстовой блок с удалением лишних пробелов,
            переносов строк и форматированием текста
          </span>
        </p>
        <div className='hidden' data-richtext-state='empty' />
      </div>
    );
  }

  return <div className='hidden' data-richtext-state='empty' />;
};
